export default __webpack_public_path__ + "static/media/drag.b9af3460.svg";